import styled from 'styled-components'

export const SwitchContainer = styled.div`
  margin-top: 25px;
`
